var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      staticClass: "ah-product-section"
    },
    [
      _c("header", { staticClass: "ah-product-section-header" }, [
        _c("h2", { staticClass: "ah-product-section-heading" }, [
          _vm._v("\n      " + _vm._s(_vm.heading) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ah-product-section-items row" },
        _vm._l(_vm.products, function(product, i) {
          return product.isMaterial === false || _vm.categoryId === 3000
            ? _c("product-card", {
                key: "product-" + i,
                staticClass:
                  "ah-product-section-item col-xl-3 col-lg-4 col-md-4 col-sm-6",
                attrs: {
                  image: product.image,
                  species: product.species,
                  category: _vm.heading,
                  heading: product.name,
                  excerpt: product.description,
                  links: product.links,
                  isMaterial: product.isMaterial
                }
              })
            : _vm._e()
        }),
        1
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "ah-product-section-footer" }, [
        _vm.showExpandButton
          ? _c(
              "button",
              {
                staticClass: "ah-product-section-expand-button",
                on: { click: _vm.expand }
              },
              [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }